import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { useToast } from '../../../../providers/ToastProvider';
import { copyToClipboard } from '../../../../utils/clipboard';

interface ReferencePillProps {
    referenceNo: string;
    className?: string;
}

// Prominent, one-click-copyable reference treatment (read aloud to callers).
// Table rows use the lighter ReferenceInline instead.
export function ReferencePill({ referenceNo, className = '' }: ReferencePillProps) {
    const { showToast } = useToast();

    const handleCopy = async (e: React.MouseEvent) => {
        e.stopPropagation();
        const copied = await copyToClipboard(referenceNo);
        showToast(
            copied ? 'Reference copied' : 'Could not copy reference',
            copied ? 'success' : 'error'
        );
    };

    return (
        <div className={`flex flex-col ${className}`.trim()}>
            <button
                type="button"
                onClick={handleCopy}
                title="Copy, read this to the caller"
                className="group flex items-center gap-2"
            >
                <span className="font-mono tabular-nums text-[19px] font-bold tracking-tight text-gray-900">
                    {referenceNo}
                </span>
                <span className="w-6 h-6 rounded-md border border-gray-200 flex items-center justify-center text-gray-400 group-hover:text-gray-900 group-hover:border-gray-300 transition-colors shrink-0">
                    <ClipboardDocumentIcon className="h-3.5 w-3.5" />
                </span>
            </button>
        </div>
    );
}
